var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrowGray32 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 33"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#9D9D9D",
  strokeWidth: 1.3,
  d: "m13.5 11.5 5 5-5 5"
})));
export default SvgIconArrowGray32;